import React from "react";
import { Link as RouterLink } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";
import { NavData } from "../../models/NavData";
import { MAIN } from "../../Routing/routes";

interface IProps {
  item: NavData;
  pathname: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    listItem: {
      marginTop: 7,
      marginLeft: "5%",
      width: "90%",
      textTransform: "uppercase",
      borderRadius: 10,
      textAlign: "center",
      color: "#fff",
      backgroundColor: theme.palette.secondary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        color: "#3db0e2 !important",
      },
    },
    selected: {
      backgroundColor: `#fff!important`,
      color: `#3db0e2`,
      "&:hover": {
        backgroundColor: `${theme.palette.primary.main}!important`,
        color: "#fff !important",
      },
    },
    itemText: {
      letterSpacing: 1,
      fontSize: 12,
      fontWeight: "bold",
      color: `#3db0e2`,
      "&:hover": {
        color: "#fff !important",
      },
    },
  })
);

const NavButton: React.FC<IProps> = ({ item, pathname }: IProps) => {
  const classes = useStyles();
  const isSelected = (path: string) =>
    (pathname.includes(path) && path !== MAIN) || (path === pathname && path === MAIN);

  return (
    <Link component={RouterLink} to={item.path} style={{ textDecoration: "none" }}>
      <ListItem
        button
        selected={isSelected(item.path)}
        classes={{ selected: classes.selected, root: classes.listItem }}
      >
        <ListItemText classes={{ primary: classes.itemText }} primary={item.name} />
      </ListItem>
      <Divider />
    </Link>
  );
};

export default NavButton;
